import {useActivateApiAbTestCallback} from '@aboutyou/feature-flags';
import {useEffect} from 'react';

export const useApiABTestSimilarItems = () => {
  const activateApiAbTest = useActivateApiAbTestCallback();

  useEffect(() => {
    activateApiAbTest('ab_visual_si_reco_fe_w');
  }, [activateApiAbTest]);
};
